import { CONSTANTS } from "src/app/constants";
import { IFlowmeter } from "../interfaces/flowmeter.interface";

export class Flowmeter implements IFlowmeter {
  flowmeterId: string;
  flowmeterName: string;
  DMDSAverageFlowrate: number;
  flowmetermodelName: string;
  flowmetermodelId: string;
  fieldprotocolName: string;
  telemetrysuppliername: string;

  constructor(flowmeter: IFlowmeter) {
    Object.keys(flowmeter).map(key => this[key] = flowmeter[key]);
  }

  get isNoFlowmeter(): boolean {
    return this.flowmeterId.includes(CONSTANTS.EQUIPMENTS.NO_FLOWMETER);
  }
}